module.exports = __webpack_public_path__ + "img/poster.e5fed024.png";